import * as XLSX from 'xlsx-js-style'
import { applySubActivityStyles, processSubActivities } from './subActivityUtilities'

type XlsxData = {
  activities: Array<Record<string, any>>
  headers: Array<string>
  subHeaders?: { label: string; value: string; placement: string }[]
}

const calculateColumnWidths = (headers: string[]) => {
  const columnWidths = headers.map(header => {
    return { wch: header.length + 8 }
  })

  return columnWidths
}

export const downloadCSV = (data: string | XlsxData, fileName: string) => {
  if (typeof data !== 'string' && data.subHeaders) {
    const { activities, headers, subHeaders } = data
    const ws = XLSX.utils.json_to_sheet([])

    const { rows, levels } = processSubActivities(activities, subHeaders)

    const filteredHeaders = headers.filter(header => header !== 'Sub Activities')
    XLSX.utils.sheet_add_aoa(ws, [filteredHeaders])
    XLSX.utils.sheet_add_json(ws, rows, { skipHeader: true, origin: -1 })

    const columnWidths = calculateColumnWidths(filteredHeaders)
    ws['!cols'] = columnWidths

    const range = XLSX.utils.decode_range(ws['!ref']!)
    ws['!rows'] = levels.map(level => ({
      hidden: false,
      level: level.level,
    }))

    applySubActivityStyles(ws, range, rows, levels, subHeaders)

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, ws, 'Activities')
    XLSX.writeFile(workbook, `${fileName}.xlsx`)
  } else {
    const blob = new Blob([data as string], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)

    const hiddenElement = document.createElement('a')
    hiddenElement.href = url
    hiddenElement.target = '_blank'
    hiddenElement.download = `${fileName}.csv`
    hiddenElement.click()
    hiddenElement.remove()
  }
}
